module.exports = __webpack_public_path__ + "img/quest.28a20d4e.png";